export const allowedUrls = [
  /^https?:\/\/[a-zA-Z0-9\-\.]*usebraintrust\.com(?:\/.*)?$/,
];
